var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuizIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256.567 290.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "m152.596,196.382c11.214-5.625,20.683-20.861,20.683-41.401,0-25.274-15.627-48.378-46.313-48.378-29.975,0-47.951,22.355-47.951,50.336,0,31.505,20.611,47.168,41.828,48.771,2.35.214,4.806.569,6.978,1.53,13.67,5.91,24.492,10.253,38.482,14.453l7.262-19.579c-7.227-1.566-14.56-3.062-20.968-5.126v-.605Zm-26.379-11.035c-12.388,0-20.077-11.891-20.006-29.227-.036-16.874,7.796-29.156,20.006-29.156,12.425,0,19.864,12.211,19.864,29.049,0,17.443-7.298,29.334-19.864,29.334Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "current",
    x: 88.421,
    width: 79.724,
    height: 18.817,
    rx: 7.893,
    ry: 7.893
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "m32.446,51.506c2.528,3.551,7.456,4.381,11.008,1.853l9.026-6.426c3.551-2.528,4.381-7.456,1.853-11.008l-.099-.139c-2.528-3.551-7.456-4.381-11.008-1.853l-9.026,6.425c-3.551,2.528-4.381,7.457-1.853,11.008l.099.139Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "m128.283,34.063C57.435,34.063,0,91.498,0,162.347s57.435,128.283,128.283,128.283c14.566,0,28.566-2.426,41.615-6.904h79.764v-79.764c4.478-13.05,6.904-27.049,6.904-41.615,0-70.848-57.435-128.283-128.283-128.283Zm0,231.61c-57.061,0-103.326-46.265-103.326-103.326s46.265-103.326,103.326-103.326,103.326,46.265,103.326,103.326-46.265,103.326-103.326,103.326Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizIcon);
export default __webpack_public_path__ + "static/media/quizIcon.518042dd78251846ed5ce0d6247a671d.svg";
export { ForwardRef as ReactComponent };